import React from 'react';

export default function AboutUsPage() {
  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">About VitaBridge</h1>
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-green-700 mb-4">Our Mission</h2>
            <p className="text-gray-600 leading-relaxed">
              Our mission is to bridge the information and resource gap for rural households in India. We believe that by providing access to modern agricultural knowledge, financial literacy, and a supportive community network, we can empower families to achieve food security, improve their livelihoods, and build a more resilient future.
            </p>
          </div>
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-green-700 mb-4">Our Team</h2>
            <p className="text-gray-600 leading-relaxed">
              We are a passionate team of social workers, agricultural experts, and technologists dedicated to creating sustainable change. Our diverse backgrounds allow us to tackle challenges from multiple perspectives, ensuring our solutions are both innovative and grounded in the realities of rural life.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-green-700 mb-4">Our Partners</h2>
            <p className="text-gray-600 leading-relaxed">
              We collaborate with a network of respected NGOs and local community organizations across the country. These partnerships are crucial for our on-the-ground presence, helping us to establish and run the Local Access Hubs and ensure our programs are tailored to the specific needs of each region.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}


